import { render } from "./Nottimes.vue?vue&type=template&id=1335e68c"
import script from "./Nottimes.vue?vue&type=script&lang=js"
export * from "./Nottimes.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__